/**
 * Centralized access to Vite environment variables.
 *
 * Wrapping `import.meta.env` here lets jest mock it without needing ESM
 * support in the test runner.
 */

function withTrailingSlash(url: string | undefined): string | undefined {
  if (!url) return url;
  return url.endsWith("/") ? url : `${url}/`;
}

export const env = {
  appVersion: import.meta.env.VITE_APP_VERSION,
  mode: import.meta.env.MODE,
  firebaseConfigName: import.meta.env.VITE_FIREBASE_CONFIG_NAME,
  skedLinkBackendApiUrl: import.meta.env.VITE_SKED_LINK_BACKEND_API_URL,
  schedugramServerBackendUrl: withTrailingSlash(
    import.meta.env.VITE_SCHEDUGRAM_SERVER_BACKEND_URL
  ),
  skedLinkPublicDomain: import.meta.env.VITE_SKED_LINK_PUBLIC_DOMAIN,
  otelEnabled: import.meta.env.VITE_OTEL_ENABLED,
  otelSampleRate: import.meta.env.VITE_OTEL_SAMPLE_RATE,
  otelEndpoint: import.meta.env.VITE_OTEL_ENDPOINT,
  otelAuthHeader: import.meta.env.VITE_OTEL_AUTH_HEADER,
  otelOrg: import.meta.env.VITE_OTEL_ORG,
  otelStream: import.meta.env.VITE_OTEL_STREAM,
  rumClientToken: import.meta.env.VITE_RUM_CLIENT_TOKEN,
  rumOrg: import.meta.env.VITE_RUM_ORG,
  rumSessionSampleRate: import.meta.env.VITE_RUM_SESSION_SAMPLE_RATE,
  rumSessionReplaySampleRate: import.meta.env
    .VITE_RUM_SESSION_REPLAY_SAMPLE_RATE,
} as const;
